module.exports = __webpack_public_path__ + "52c5144f9437ab386c1d930acbea3f04.png";